import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { aboutPlatforms } from '@/mocks/strategix';

export default function AboutPlatforms() {
  return (
    <section className="relative w-full px-5 md:px-10 py-20 md:py-28 bg-background-100/50">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="Рекламные площадки"
          title="Запускаем рекламу там, где живёт ваша аудитория"
          description="Наша основная специализация — продвижение сообществ на разных площадках, а также сайтов и каналов. У каждой площадки — своя аудитория и роль в воронке: где-то ловим горячий спрос, где-то формируем доверие, где-то доводим тёплых лидов до покупки."
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {aboutPlatforms.map((platform, index) => (
            <Reveal key={platform.name} delay={index * 70} className="h-full">
              <div className="group h-full p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-400/60 transition-colors">
                <div className="flex items-center justify-between">
                  <span
                    className="w-12 h-12 flex items-center justify-center rounded-md text-white text-xl transition-transform group-hover:scale-105"
                    style={{ backgroundColor: platform.color }}
                  >
                    {platform.icon ? (
                      <i className={`${platform.icon} text-lg`}></i>
                    ) : (
                      <span className="font-heading font-bold text-sm">{platform.mark}</span>
                    )}
                  </span>
                  {platform.reach ? (
                    <span className="px-3 py-1 rounded-full bg-accent-500/15 text-accent-300 text-xs font-semibold whitespace-nowrap">
                      {platform.reach} в месяц
                    </span>
                  ) : null}
                </div>

                <h3 className="mt-5 font-heading text-base md:text-lg text-foreground-950">{platform.name}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{platform.text}</p>

                <p className="mt-4 text-sm text-foreground-700 leading-relaxed border-t border-background-200/70 pt-4">
                  {platform.details}
                </p>

                <ul className="mt-4 space-y-2">
                  {platform.formats.map((format) => (
                    <li key={format} className="flex items-start gap-2 text-sm text-foreground-600">
                      <i className="ri-check-line text-primary-400 mt-0.5"></i>
                      <span>{format}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}